export const NeradniDanResourcesBS: NeradniDanResourcesInterface = {
  title: "Neradni dan",
  subtitle:
    "Obrišite sve planirane i popunjene evidencije (tipa Redovna) za odabrane poslovnice na odabrani dan.",
  warning:
    "Pažnja: Akcija je nepovratna. Obrisati će se i popunjene evidencije (uključujući one automatski popunjene) i neispunjene planirane tačke primjene za taj dan.",
  selectBranches: "Poslovnice",
  selectBranchesPlaceholder: "Odaberite jednu ili više poslovnica...",
  selectAllBranches: "Odaberi sve",
  clearAllBranches: "Očisti odabir",
  selectDate: "Datum",
  previewButton: "Pregled",
  deleteButton: "Neradni dan - Obriši",
  deleting: "Brisanje u toku...",
  loadingPreview: "Učitavanje pregleda...",
  previewTitle: "Pregled - šta će biti obrisano",
  previewEmpty:
    "Za odabrani datum i poslovnice nema planiranih evidencija tipa 'Redovna'.",
  recordPointsCount: "Broj tačaka primjene",
  evidencesCount: "Broj evidencija",
  evidenceTypeColumn: "Tip evidencije",
  countColumn: "Broj",
  totalRow: "UKUPNO",
  groupsTitle: "Označite šta želite obrisati",
  groupsHint:
    "Sve evidencije su unaprijed označene. Skinite kvačicu sa onih koje NE želite brisati.",
  groupSelectAll: "Označi sve",
  groupClearAll: "Skini sve oznake",
  groupSelectedSummary:
    "Odabrano: {{selected}} od {{total}} evidencija ({{rps}} tačaka primjene, {{evds}} zapisa).",
  groupColumnEvidence: "Evidencija",
  groupColumnBranch: "Poslovnica",
  groupColumnRpCount: "Tač. primjene",
  groupColumnEvdCount: "Zapisa",
  validationNoSelection:
    "Označite barem jednu evidenciju za brisanje.",
  needPreviewFirst:
    "Prvo uradite pregled, pa odaberite šta želite obrisati.",
  confirmTitle: "Potvrda brisanja",
  confirmMessage:
    "Da li ste sigurni da želite OBRISATI evidencije za odabrani dan? Ova akcija se NE MOŽE poništiti.",
  confirmYes: "Da, obriši",
  confirmNo: "Odustani",
  successTitle: "Brisanje uspješno",
  successMessage:
    "Uspješno obrisano {{evidences}} evidencija u {{recordPoints}} tačaka primjene.",
  errorTitle: "Greška",
  errorGeneric: "Došlo je do greške prilikom izvršavanja operacije.",
  errorLoadingBranches:
    "Neuspješno učitavanje liste poslovnica. Provjerite konekciju i pokušajte ponovo.",
  errorNetwork: "Nema veze sa serverom. Provjerite internet konekciju.",
  errorForbidden: "Nemate dozvolu za izvršavanje ove operacije.",
  errorNotFound: "Traženi resurs nije pronađen.",
  errorServer: "Greška na serveru. Pokušajte ponovo za nekoliko trenutaka.",
  errorTimeout: "Zahtjev je istekao. Molimo pokušajte ponovo.",
  retry: "Pokušaj ponovo",
  dismiss: "Zatvori",
  validationNoBranch: "Molimo odaberite barem jednu poslovnicu.",
  validationNoDate: "Molimo odaberite datum.",
  loadingBranches: "Učitavanje poslovnica...",
  executingOverlayTitle: "Brisanje u toku",
  executingOverlayMessage:
    "Brisanje evidencija može potrajati nekoliko trenutaka. Molimo ne zatvarajte stranicu.",
};

export const NeradniDanResourcesEN: NeradniDanResourcesInterface = {
  title: "Non-working day",
  subtitle:
    "Delete all scheduled and filled evidence entries (type 'Regular') for the selected branches on the selected date.",
  warning:
    "Warning: This action is irreversible. It removes both filled evidences (including auto-filled ones) and unfilled scheduled record points for that day.",
  selectBranches: "Branches",
  selectBranchesPlaceholder: "Select one or more branches...",
  selectAllBranches: "Select all",
  clearAllBranches: "Clear selection",
  selectDate: "Date",
  previewButton: "Preview",
  deleteButton: "Non-working day - Delete",
  deleting: "Deleting...",
  loadingPreview: "Loading preview...",
  previewTitle: "Preview - what will be deleted",
  previewEmpty:
    "No scheduled evidence entries of type 'Regular' for the selected date and branches.",
  recordPointsCount: "Record points",
  evidencesCount: "Evidence entries",
  evidenceTypeColumn: "Evidence type",
  countColumn: "Count",
  totalRow: "TOTAL",
  groupsTitle: "Pick what you want to delete",
  groupsHint:
    "All evidences are checked by default. Uncheck the ones you do NOT want to delete.",
  groupSelectAll: "Select all",
  groupClearAll: "Clear selection",
  groupSelectedSummary:
    "Selected: {{selected}} of {{total}} evidences ({{rps}} record points, {{evds}} entries).",
  groupColumnEvidence: "Evidence",
  groupColumnBranch: "Branch",
  groupColumnRpCount: "Record pts.",
  groupColumnEvdCount: "Entries",
  validationNoSelection:
    "Select at least one evidence to delete.",
  needPreviewFirst:
    "Run a preview first, then choose what to delete.",
  confirmTitle: "Confirm deletion",
  confirmMessage:
    "Are you sure you want to DELETE the evidence entries for the selected day? This action CANNOT be undone.",
  confirmYes: "Yes, delete",
  confirmNo: "Cancel",
  successTitle: "Deletion successful",
  successMessage:
    "Successfully deleted {{evidences}} evidence entries across {{recordPoints}} record points.",
  errorTitle: "Error",
  errorGeneric: "An error occurred while executing the operation.",
  errorLoadingBranches:
    "Failed to load the list of branches. Check your connection and try again.",
  errorNetwork: "Cannot reach the server. Check your internet connection.",
  errorForbidden: "You do not have permission to perform this operation.",
  errorNotFound: "The requested resource was not found.",
  errorServer: "Server error. Please try again in a few moments.",
  errorTimeout: "The request timed out. Please try again.",
  retry: "Retry",
  dismiss: "Dismiss",
  validationNoBranch: "Please select at least one branch.",
  validationNoDate: "Please select a date.",
  loadingBranches: "Loading branches...",
  executingOverlayTitle: "Deletion in progress",
  executingOverlayMessage:
    "Deleting evidence entries may take a few moments. Please do not close the page.",
};

export const NeradniDanResourcesDE: NeradniDanResourcesInterface = {
  title: "Arbeitsfreier Tag",
  subtitle:
    "Löschen Sie alle geplanten und ausgefüllten Evidenzeinträge (Typ 'Regelmäßig') für die ausgewählten Filialen am ausgewählten Tag.",
  warning:
    "Achtung: Diese Aktion ist unumkehrbar. Sowohl ausgefüllte Evidenzen (auch automatisch ausgefüllte) als auch nicht ausgefüllte geplante Messpunkte für diesen Tag werden entfernt.",
  selectBranches: "Filialen",
  selectBranchesPlaceholder: "Eine oder mehrere Filialen auswählen...",
  selectAllBranches: "Alle auswählen",
  clearAllBranches: "Auswahl aufheben",
  selectDate: "Datum",
  previewButton: "Vorschau",
  deleteButton: "Arbeitsfreier Tag - Löschen",
  deleting: "Wird gelöscht...",
  loadingPreview: "Vorschau wird geladen...",
  previewTitle: "Vorschau - was gelöscht wird",
  previewEmpty:
    "Keine geplanten Evidenzeinträge vom Typ 'Regelmäßig' für das ausgewählte Datum und die ausgewählten Filialen.",
  recordPointsCount: "Messpunkte",
  evidencesCount: "Evidenzeinträge",
  evidenceTypeColumn: "Evidenztyp",
  countColumn: "Anzahl",
  totalRow: "GESAMT",
  groupsTitle: "Wählen Sie aus, was gelöscht werden soll",
  groupsHint:
    "Alle Evidenzen sind standardmäßig ausgewählt. Entfernen Sie das Häkchen bei denen, die NICHT gelöscht werden sollen.",
  groupSelectAll: "Alle auswählen",
  groupClearAll: "Auswahl aufheben",
  groupSelectedSummary:
    "Ausgewählt: {{selected}} von {{total}} Evidenzen ({{rps}} Messpunkte, {{evds}} Einträge).",
  groupColumnEvidence: "Evidenz",
  groupColumnBranch: "Filiale",
  groupColumnRpCount: "Messpunkte",
  groupColumnEvdCount: "Einträge",
  validationNoSelection:
    "Wählen Sie mindestens eine Evidenz zum Löschen aus.",
  needPreviewFirst:
    "Führen Sie zuerst eine Vorschau aus und wählen Sie dann aus, was gelöscht werden soll.",
  confirmTitle: "Löschen bestätigen",
  confirmMessage:
    "Möchten Sie die Evidenzeinträge für den ausgewählten Tag wirklich LÖSCHEN? Diese Aktion kann NICHT rückgängig gemacht werden.",
  confirmYes: "Ja, löschen",
  confirmNo: "Abbrechen",
  successTitle: "Löschen erfolgreich",
  successMessage:
    "{{evidences}} Evidenzeinträge in {{recordPoints}} Messpunkten wurden erfolgreich gelöscht.",
  errorTitle: "Fehler",
  errorGeneric: "Beim Ausführen des Vorgangs ist ein Fehler aufgetreten.",
  errorLoadingBranches:
    "Filialliste konnte nicht geladen werden. Prüfen Sie die Verbindung und versuchen Sie es erneut.",
  errorNetwork:
    "Der Server ist nicht erreichbar. Bitte prüfen Sie Ihre Internetverbindung.",
  errorForbidden: "Sie haben keine Berechtigung für diese Aktion.",
  errorNotFound: "Die angeforderte Ressource wurde nicht gefunden.",
  errorServer: "Serverfehler. Bitte versuchen Sie es in Kürze erneut.",
  errorTimeout: "Die Anfrage ist abgelaufen. Bitte erneut versuchen.",
  retry: "Erneut versuchen",
  dismiss: "Schließen",
  validationNoBranch: "Bitte wählen Sie mindestens eine Filiale aus.",
  validationNoDate: "Bitte wählen Sie ein Datum aus.",
  loadingBranches: "Filialen werden geladen...",
  executingOverlayTitle: "Löschvorgang läuft",
  executingOverlayMessage:
    "Das Löschen der Evidenzeinträge kann einige Augenblicke dauern. Bitte schließen Sie die Seite nicht.",
};

export interface NeradniDanResourcesInterface {
  title: string;
  subtitle: string;
  warning: string;
  selectBranches: string;
  selectBranchesPlaceholder: string;
  selectAllBranches: string;
  clearAllBranches: string;
  selectDate: string;
  previewButton: string;
  deleteButton: string;
  deleting: string;
  loadingPreview: string;
  previewTitle: string;
  previewEmpty: string;
  recordPointsCount: string;
  evidencesCount: string;
  evidenceTypeColumn: string;
  countColumn: string;
  totalRow: string;
  confirmTitle: string;
  confirmMessage: string;
  confirmYes: string;
  confirmNo: string;
  successTitle: string;
  successMessage: string;
  errorTitle: string;
  errorGeneric: string;
  errorLoadingBranches: string;
  errorNetwork: string;
  errorForbidden: string;
  errorNotFound: string;
  errorServer: string;
  errorTimeout: string;
  retry: string;
  dismiss: string;
  validationNoBranch: string;
  validationNoDate: string;
  loadingBranches: string;
  executingOverlayTitle: string;
  executingOverlayMessage: string;
  groupsTitle: string;
  groupsHint: string;
  groupSelectAll: string;
  groupClearAll: string;
  groupSelectedSummary: string;
  groupColumnEvidence: string;
  groupColumnBranch: string;
  groupColumnRpCount: string;
  groupColumnEvdCount: string;
  validationNoSelection: string;
  needPreviewFirst: string;
}
